import React, { useEffect, useRef, useState } from "react";
import Matter from "matter-js";
import {
    SiCypress,
    SiGraphql,
    SiStorybook,
    SiVisualstudiocode,
    SiWindows,
    SiIntellijidea,
    SiMongodb,
    SiDocker,
    SiPostman,
    SiNextdotjs,
    SiNestjs
} from "react-icons/si";
import {DiGit} from "react-icons/di";

export default function ToolsPhysics() {
    const sceneRef = useRef(null);
    const [bodies, setBodies] = useState([]);

    useEffect(() => {
        const { Engine, Render, Runner, World, Bodies, Events, Mouse, MouseConstraint } = Matter;

        const engine = Engine.create();
        engine.gravity.y = 1;

        const width = 700;
        const height = 600;

        const render = Render.create({
            element: sceneRef.current,
            engine: engine,
            options: {
                width,
                height,
                wireframes: false,
                background: "transparent",
            },
        });
        render.canvas.style.pointerEvents = "auto";

        // ✅ skills
        const skills = [
            { icon: <SiWindows size={90} />, size: 80 },
            { icon: <SiVisualstudiocode size={90} />, size: 80 },
            { icon: <SiGraphql size={90} />, size: 80 },
            { icon: <SiCypress size={90} />, size: 80 },
            { icon: <SiStorybook size={90} />, size: 80 },
            { icon: <SiIntellijidea size={90} />, size: 80 },
            { icon: <SiMongodb size={90} />, size: 80 },
            { icon: <SiDocker size={90} />, size: 80 },
            { icon: <SiPostman size={90} />, size: 80 },
            { icon: <DiGit size={90} />, size: 80 },
        ];

        // ✅ create circles
        const skillBodies = []
        skills.forEach((skill, i) => {
            setTimeout(() => {
                const body = Bodies.circle(
                    width / 2, // ✅ center X
                    -1000,       // ✅ start above view
                    70,
                    {
                        restitution: 0.6,      // less bouncy
                        friction: 0.1,         // moderate friction to slow sliding
                        frictionStatic: 0.3,   // makes bodies settle quickly
                        frictionAir: 0.02,     // small air resistance
                        density: 0.002,        // moderate mass
                        slop: 0.01,             // collision tolerance
                        render: {
                            fillStyle: "transparent",
                            strokeStyle: "white",
                            lineWidth: 4,
                        },
                    }
                );
                body.skill = skill;
                skillBodies.push(body);
                World.add(engine.world, body);
            }, i * 300); // ⏱️ 0.5s delay between each
        });

        // ✅ walls (box)
        const thickness = 20;

        const floor = Bodies.rectangle(width / 2, height - 10, width, 20, {
            isStatic: true,
            render: { fillStyle: "white" },
        });

        const leftWall = Bodies.rectangle(
            thickness / 2,
            height / 2,
            thickness,
            height,
            {
                isStatic: true,
                render: { fillStyle: "white" },
                chamfer: { radius: 10 }
            }
        );

        const rightWall = Bodies.rectangle(
            width - thickness / 2,
            height / 2,
            thickness,
            height,
            {
                isStatic: true,
                render: { fillStyle: "white" },
                chamfer: { radius: 10  }
            }
        );

        const mouse = Mouse.create(render.canvas);

        const mouseConstraint = MouseConstraint.create(engine, {
            mouse: mouse,
            constraint: {
                stiffness: 0.2, // how "tight" the drag feels
                render: {
                    visible: false, // hide line
                },
            },
        });

        // World.add(engine.world, mouseConstraint);

// keep mouse in sync with renderer
        World.add(engine.world, [...skillBodies, floor, leftWall, rightWall, mouseConstraint]);

        render.mouse = mouse;
        Render.run(render);

        const runner = Runner.create();
        Runner.run(runner, engine);

        // ✅ sync physics → React
        Events.on(engine, "afterUpdate", () => {
            setBodies([...skillBodies]);
        });

        return () => {
            Render.stop(render);
            Runner.stop(runner);
            Engine.clear(engine);
            render.canvas.remove();
        };
    }, []);

    return (
        <div style={{ justifyContent: "center", display: "flex" }}>
            <div
                ref={sceneRef}
                style={{ position: "relative", width: "700px", height: "600px", display: "flex", justifyContent: "center", overflow: "hidden" }}
            >
                {/* ✅ ICONS OVERLAY */}
                {bodies.map((body, i) => (
                    <div
                        key={i}
                        style={{
                            position: "absolute",
                            left: body.position.x,
                            top: body.position.y,
                            transform: `translate(-50%, -50%) rotate(${body.angle}rad)`, // ✅ rotation
                            width: body.skill.size,
                            height: body.skill.size,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        {body.skill.icon}
                    </div>
                ))}
            </div>
        </div>
    );
}